import { Base64 } from "js-base64";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

export const readFileAsBase64 = (file: File): Promise<string> =>
  file.arrayBuffer().then((buffer) => Base64.fromUint8Array(new Uint8Array(buffer)));

export const buildFullFilePaths = (files: File[], folderPath: string): string[] =>
  files.map((f) => (folderPath ? `${folderPath}/${f.name}` : f.name));

export const partitionByFileSize = (
  files: File[]
): { validFiles: File[]; oversizedFileNames: string[] } => {
  const validFiles: File[] = [];
  const oversizedFileNames: string[] = [];

  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      oversizedFileNames.push(file.name);
    } else {
      validFiles.push(file);
    }
  }

  return { validFiles, oversizedFileNames };
};

export const partitionByDuplicates = (
  files: File[],
  existingNames: Set<string>
): { uniqueFiles: File[]; duplicateNames: string[] } => {
  const uniqueFiles: File[] = [];
  const duplicateNames: string[] = [];

  for (const file of files) {
    if (existingNames.has(file.name)) {
      duplicateNames.push(file.name);
    } else {
      uniqueFiles.push(file);
    }
  }

  return { uniqueFiles, duplicateNames };
};

export const partitionByConflicts = (
  files: File[],
  existingPaths: Set<string>,
  folderPath: string
): { conflictingPaths: string[]; nonConflictingFiles: File[] } => {
  const conflictingPaths: string[] = [];
  const nonConflictingFiles: File[] = [];

  for (const file of files) {
    const fullPath = folderPath ? `${folderPath}/${file.name}` : file.name;

    if (existingPaths.has(fullPath)) {
      conflictingPaths.push(fullPath);
    } else {
      nonConflictingFiles.push(file);
    }
  }

  return { conflictingPaths, nonConflictingFiles };
};
